/**
 * Created by lobin on 2019/1/21.
 */
import { request } from "../../plugins/axios";
const state = {
  captcha: `${process.env.VUE_APP_APIBASEURL}/portal/captcha.png?id=`,
  info: null,
  detail: {},

  // 求职反馈
  jobseekerlist:[], //求职反馈的状态（查看，筛选通过。。。。。）
  febacklist:[],
  febackPagination:{},
  
  // 收藏
  favoritelist:[],
  favoPagination:{},
};
const getters = {
  isLogin: state => (state.info ? true : false)
};

const actions = {
  async getUserInfo({ commit }) {
    const { data } = await request({
      url: "/portal/job-seekers/info?language=1"
    });
    commit("userSetState", { key: "detail", data: data || {} });
  },
  /**
   * 获取当前用户信息
   */
  async getSelfUserInfo({ commit, dispatch }) {
    const { data, code } = await request({ url: "portal/users/selfInfos" });
    if (!data) {
      return code;
    }
    const progress = await dispatch("getResumeProgress");
    const positionStatistics = await dispatch("getPositionStatistics");
    if (progress) {
      data.progress = progress;
    }
    if (positionStatistics) {
      data.positionStatistics = positionStatistics;
    }
    commit("userSetState", { key: "info", data });
  },
  /**
   * 获取当前用户在线简历完整度
   */
  async getResumeProgress({}) {
    const { data } = await request({ url: "/portal/resume/online/progress" });
    if (data) return data;
  },
  /**
   * 获取自己职位统计情况
   */
  async getPositionStatistics({}) {
    const { data } = await request({ url: "/portal/delivery/statistics" });
    if (data) return data;
  },
  /**
   * 用户登录
   * @param data
   * @return {Promise.<void>}
   */
  async login({}, data) {
    return request({
      // url: "/portal/oauth2/token",
      url: "/portal/login/token",
      
      method: "POST",
      data
    });
  },
  /**
   * 退出登录
   */
  loginout({ commit }) {
    commit("userSetState", { key: "info", data: null });
    return request({ url: "/platform/oauth2/logout" });
  },
  /**
   * 验证电话号码是否存在
   * @param mobile:number
   * @return {Promise.<void>}
   */
  async checkMobile({}, mobile) {
    return request({
      url: `/portal/users/check/mobile/${mobile}`
    });
  },
  /**
   * 发送短信验证码
   * @param data
   * @return {Promise.<void>}
   */
  async sendVcode({}, data) {
    return request({
      url: "/portal/message/sms/send/captcha",
      method: "POST",
      data
    });
  },
  /**
   * 求职者注册
   * @param data
   * @return {Promise.<void>}
   */
  async register({}, data) {
    return request({
      url: "/portal/register",
      method: "POST",
      data
    });
  },
  /**
   * 获取附件简历
   * @param data
   * @return {Promise.<void>}
   */
  async accessoryResume({}) {
    return request({
      url: "/portal/resume/online"
    });
  },
  /**
   * 修改用户信息
   * @param data
   * @return {Promise.<void>}
   */
  async modifyUserInfo({}, data) {
    return request({
      url: `/platform/users/${data.id}`,
      method: "put",
      data
    });
  },
  async wechatLogin({}, code) {
    return request({
      url: `/portal/wechat/scanLogin?code=${code}&state=state`
    });
  },
  async wechatBond({}, code) {
    return request({
      url: `/portal/wechat/binding?code=${code}&state=state`
    });
  },
  /**
   * 个人中心-->求职反馈的状态（投递成功，被查看。。。。。。）
   * @param data
   * @return {Promise.<void>}
   */
  async jobseekerState({commit},) {
    const {data} = await request({
      url: `/portal/jobseekerState/personCenterState`
    });
    commit("userSetState", { key: "jobseekerlist", data: data});
  },

    /**
   * 个人中心-->求职反馈列表
   * @param data
   * @return {Promise.<void>}
   */
    async getFeedBackList({commit},params) {
      const {data,pagination} = await request({
        url: `/portal/delivery`,
        params
      });
      commit("userSetState", { key: "febacklist", data: data});
      if(data){
        commit("userSetState", { key: "febackPagination", data: pagination});
      }
    },

  /**
   * 个人中心-->收藏的职位
   * @param data
   * @return {Promise.<void>}
   */
  async collectFavorite({commit},params) {
    const {data,pagination} = await request({
      url: `/portal/position/favorites`,
      params
    });
    commit("userSetState", { key: "favoritelist", data: data});
    if(data){
      commit("userSetState", { key: "favoPagination", data: pagination});
    }
  },





  



};
const mutations = {
  userSetState(state, { key, data }) {
    state[key] = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
